var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification",class:_vm.colorClass},[_c('button',{staticClass:"delete",on:{"click":function($event){return _vm.$emit('remove', _vm.id)}}}),_vm._t("default",[_vm._v(_vm._s(_vm.labelTr))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }